<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/L3CaOD/tc-custom/9781504024662.jpg?1705026343061" alt="This image is the cover for the book Persian Price"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Persian Price
      </h1>
      <p class="bookDescription body article font2">
        <b>A wife and mother becomes the target of terrorists in this mesmerizing thriller that sweeps from Iran to England to the South of France </b><br/>  <br/> Eileen Field, the unhappy, neglected wife of the chairman of the world’s most powerful oil conglomerate, arrives in Tehran with her husband, Logan Field, for a reception honoring the Shah’s minister of the economy. Logan needs the Shah on his side in order to win the bid to build a refinery in Iran. At the hotel, violent tensions bubble just beneath the surface, for the minister has his own agenda—and now a man has been savagely murdered. But for Eileen, the ordeal is just beginning.<br/>  <br/> In her frantic efforts to protect her only child, Eileen is abducted by terrorists and taken to a villa on the French Riviera. There, locked in a room with steel bars on the window, she’s about to be ransomed—and killed if her captors’ demands aren’t met. But they don’t want money. With her life hanging in the balance, Eileen’s future is in the hands of three men: Logan, determined to make a deal between America and Iran at any cost; James Kelly, who has been secretly in love with Eileen for years; and a stranger who ignites a passion within her that could lead to unexpected romance.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Evelyn Anthony
      </h2>
      
      <p class="authorDescription body article">Evelyn Anthony is the pen name of Evelyn Ward-Thomas (1926&ndash;2108), a female British author who began writing in 1949. She gained considerable success with her historical novels&mdash;two of which were selected for the American Literary Guild&mdash;before winning huge acclaim for her espionage thrillers. Her book, <I>The Occupying Power</I>, won the Yorkshire Post Fiction Prize, and her 1971 novel, <I>The Tamarind Seed</I>, was made into a film starring Julie Andrews and Omar Sharif. Anthony&rsquo;s books have been translated into nineteen languages.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3bc7e215